__turbopack_context__.v({
  "container": "ColourPicker-module-scss-module__DaY43W__container",
  "label": "ColourPicker-module-scss-module__DaY43W__label",
  "labelRow": "ColourPicker-module-scss-module__DaY43W__labelRow",
  "overflowToggle": "ColourPicker-module-scss-module__DaY43W__overflowToggle",
  "root": "ColourPicker-module-scss-module__DaY43W__root",
  "rootCard": "ColourPicker-module-scss-module__DaY43W__rootCard",
  "selectedColourName": "ColourPicker-module-scss-module__DaY43W__selectedColourName",
  "swatchContainer": "ColourPicker-module-scss-module__DaY43W__swatchContainer",
  "swatchList": "ColourPicker-module-scss-module__DaY43W__swatchList",
  "swatchListCard": "ColourPicker-module-scss-module__DaY43W__swatchListCard",
  "swatchListItem": "ColourPicker-module-scss-module__DaY43W__swatchListItem",
  "swatchOuter": "ColourPicker-module-scss-module__DaY43W__swatchOuter",
  "swatchOverflowContainer": "ColourPicker-module-scss-module__DaY43W__swatchOverflowContainer",
  "swatchOverflowContainerExpanded": "ColourPicker-module-scss-module__DaY43W__swatchOverflowContainerExpanded",
  "swatchOverflowInner": "ColourPicker-module-scss-module__DaY43W__swatchOverflowInner",
});
